import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import { consumeMpTokens } from "./utils/mp-bridge";
import "./styles/tokens.css";
import "./styles/main.css";

// 如果 H5 被嵌入小程序 web-view，从小程序传递的 URL 参数中读取 token
// 必须在 app.mount 之前执行，确保路由守卫和 API 请求能拿到 token
consumeMpTokens();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount("#app");
